import { CRUDMutations } from '@/utils/store-utilities'

const defaultItem = (item) => ({
  ...item,
})

export const state = () => ({
  items: [],
})

export const mutations = {
  ...CRUDMutations(defaultItem),
}

export const getters = {}

export const actions = {
  addWishlist({ commit }, item) {
    return this.$axios.$post('admin/wishlists/create', { ...item }).then((response) => {
      commit('add', { ...response.data })
    })
  },
  removeWishlist({ commit }, item) {
    return this.$axios.$delete(`admin/wishlists/${item.id}`).then((response) => {
      if (response.data) {
        commit('remove', item)
      }
    })
  },
  updateWishlist({ commit }, item) {
    return this.$axios.$put(`admin/wishlists/${item.id}`, { ...item }).then((response) => {
      commit('update', { ...response.data })
    })
  },
  fetchWishlist({ commit }, id) {
    return this.$axios.$get(`admin/wishlists/${id}`).then((response) => {
      return response.data
    })
  },
  fetchWishlists({ commit }) {
    return this.$axios.$get('admin/wishlists').then((response) => {
      commit('load', response.data)
    })
  },
}
